import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus, getMonthTHFromInt, setLoader } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import RCPagination from '../UserControl/Pagination/RCPagination';
import { AlertBar, AlertConfirm } from '../../Modals/AlertBar';
import ModalConfirmDelete from '../../Modals/ModalConfirmDelete';
import { withNamespaces } from 'react-i18next'
// import TarckSummary from '../TarckSummary/TarckSummary';
import { none } from 'ol/centerconstraint';
import $ from 'jquery';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import TrackingCradList from '../../components/Monitor/TrackingCradList/TrackingCradList';
import DateTimeRange from '../../components/UserControl/DateTimeRange/DateTimeRange';
import TextBoxMultiCarFilter from '../../components/UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import { Alert } from '../../Modals/AlertBar';
import ReactToExcel from 'react-html-table-to-excel';

import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
// import  './css/print.css';
//import  './css/print.css';
import ReactToPrint from "react-to-print";
// import html2pdf from "html2pdf.js";
//import html2pdf from "html2pdf.js";
//import canvasToImage from 'Canvas2Image '
//import Canvas2Image from 'canvas2image'

//import './libs/table-export/tableExport';
//import './libs/jsPDF/jspdf.min'
//import './libs/jsPDF-AutoTable/jspdf.plugin.autotable';

//import print,{convertToJPEG} from "./js/print"
const Canvas2Image = window.Canvas2Image;
// import PDFKit from 'pdfkitjs';

let startHistoryDate = null;
let endHistoryDate = null;
let tagsHistory = null;
let tagsDevice = [];
let tagsCarAlert = null;
let m_trackHistoryList = null;
let m_trackHistory2List = null;
let token //= getMainCookie().token;
let intervalAlert;
let m_carAlertNotify = false;

class ReportSummary extends Component {

    constructor(props) {
        super(props);

        this.mapTracking = React.createRef();
        this.mapTrackingPoi = React.createRef();
        this.mapTrackingHistory = React.createRef();
        this.mapAlert = React.createRef();
        this.trackingCradListHistory = React.createRef();
        this.trackingCradList = React.createRef();
        this.carAlertList = React.createRef();

        // this.tmeHistoryStart =  React.createRef();
        // this.tmeHistoryEnd =  React.createRef();
        this.state = {
            isShowTracking: true,
            isShowTrackCardList: false,
            isShowTrackingHistory: false,
            isShowTrackHistoryCardList: false,
            isShowGroupList: false,
            selectHistoryDateRange: {
                startDate: this.getCurrentDate(new Date()),
                endDate: this.getCurrentDate(new Date()),
                startTimeHistory: "00:00",
                endTimeHistory: "23:50"
            },
            isShowPOI: false,
            isShowMapAlert: false,
            carAlertList: [],
            lonlatByMark: [],
            selectPOIByMap: "",
            isClickLoadReport: '',
            deviceNoList: [],

            isClearable: true,
            isDisabled: false,
            isLoading: false,
            isRtl: false,
            isSearchable: true,

            deviceList: [],
            currentPage: 1,
            currentPageSize: 10,
            totalPage: 0,

            checkAll: false,
            isMobile: false
        };
    }

    componentWillMount() {
        this.setState({ isMobile: window.innerWidth < 400 });
    }

    componentDidMount() {
        console.log("MapTrackingHistory componentDidMount")
        $("#mapTrackingHistory").css("height", $(window).height() - 190);

        this.getActiveDeviceUserRelated();
    }
    componentWillUnmount() {
        console.log("MapTrackingHistory componentWillUnmount");
        // clearMapTrackingHistory();
        tagsDevice = [];
        this.setState({
            device_no1: "",
            device_no2: "",
            deviceList: [],
        })
    }
    btnSearchHistoryClick = (e) => {

        if(e === undefined){
            return;
        }
            
        console.log('btnSearchHistoryClick e',e)
        console.log("btnSearchHistoryClick", this.getCurrentDate(startHistoryDate), this.state.selectHistoryDateRange.startTimeHistory, this.state.selectHistoryDateRange.endTimeHistory, tagsDevice);
        if (startHistoryDate == null || endHistoryDate == null || this.state.selectHistoryDateRange.startTimeHistory == "" || this.state.selectHistoryDateRange.endTimeHistory == "")
            Alert("กรุณาใส่ข้อมูล", "วัน เวลา ที่ต้องการดูย้อนหลัง");
        else {
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd = this.getCurrentDate(endHistoryDate).split("-")[0];
            mm = this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;


            // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
            this.getReportDeviceDaily();
            // this.getReportSummaryByDevice(stime,start,etime,end,tagsDevice);
            // this.mapTrackingPoi.current.setMapTrackingHistory(stime,start,etime,end,tagsHistory);
            console.log(stime, start, etime, end, tagsDevice)
        }

    }

    getReport() {

        console.log('getreport', this.state.deviceList)
        const { user_id, user_name, token } = this.props;
        let date = `ระหว่างวันที่ ${this.getCurrentDate(startHistoryDate) } ถึง ${this.getCurrentDate(endHistoryDate) }`;
        fetch(`http://203.150.199.244/api/report/exportPdf/11`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "title": date,
                "result_data": this.state.deviceList
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data)
                // this.downloadPDF(data.file_name);
                document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`;
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    downloadPDF(fileName) {

        console.log('fileName', fileName)
        const { user_id, user_name, token } = this.props;

        fetch(`http://203.150.199.244/api/report/download/${fileName}`, {
            method: 'get',
            headers: {
                "Content-Type": "pdf",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token
            }
        })
            .then(response => { return checkStatus(response) })
            .then(data => {

                // this.downloadPDF(data.fileName);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getCurrentDate(today) {
        //let today = new Date();
        if (today == null)
            return null;
        let dd = !today.date ? today.getDate() : today.date;
        let mm = today.months == undefined ? today.getMonth() + 1 : today.months + 1; //January is 0! today
        let yyyy = !today.years ? today.getFullYear() : today.years;
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    handleStartTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    handleEndTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    setRangeDate(sDate, eDate) {
        startHistoryDate = sDate;
        endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            startHistoryDate = sDate.toObject();
            endHistoryDate = eDate.toObject();
        }
        console.log("setRangeDate", startHistoryDate, endHistoryDate);
    }

    handleClick = (e) => {
        console.log('handleClick e',e);
        this.btnSearchHistoryClick();
        const { isClickLoadReport } = this.state;
        console.log('isClickLoadReportXXXX:', isClickLoadReport);
        if (isClickLoadReport === 'show') {
            this.setState({ isClickLoadReport: '' });
        } else {
            this.setState({ isClickLoadReport: 'show' });
        }
    }

    setMultiCar(tags) {
        tagsDevice = tags;
        console.log("tag", tagsDevice);
        // if(this.state.isShowTracking && this.mapTrackingPoi.current != null)
        //     this.mapTrackingPoi.current.searchCarTrack(tags,this.state.isShowGroupList);
    }

    getActiveDeviceUserRelated() {

        const { user_id, user_name, token } = this.props;
        console.log('tokenPOI', token)
        fetch(`http://203.150.199.244/api/admin/getActiveDeviceUserRelated/99999`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    deviceNoList: data.RESULT_DATA,
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }



    getReportSummaryByDevice(stime, start, etime, end, tagsDevice) {


        let start_date = start + " " + stime;
        let end_date = end + " " + etime;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${this.state.currentPage}/${this.state.currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "devices": tagsDevice,
                "start_date": start_date,
                "end_date": end_date
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log('report device', data)
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: this.state.currentPage,
                    currentPageSize: this.state.currentPageSize
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;


        this.setState({
            [name]: value
        });



        this.state.deviceList.map((d) => {

            // console.log("#checkId"+d.device_id)
            // $("#"+d.device_id).checked;
            let aaa = "checkId" + d.device_id;
            var object = this.refs[`${aaa}`];
            object.checked = value;
            console.log(object, d)

        })
    }

    onChangeDeviceCheck(event) {

        let object = this.refs.checkAll;
        object.checked = false;

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log(name, value)
    }

    onPageSelect(page) {

        const { currentPageSize } = this.state;
        const { user_id, user_name, token } = this.props;

        let stime = this.state.selectHistoryDateRange.startTimeHistory;
        let etime = this.state.selectHistoryDateRange.endTimeHistory;
        let start = this.getCurrentDate(startHistoryDate);
        let end = this.getCurrentDate(endHistoryDate)
        let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
        let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
        let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
        start = dd + "-" + mm + "-" + yyyy;
        dd = this.getCurrentDate(endHistoryDate).split("-")[0];
        mm = this.getCurrentDate(endHistoryDate).split("-")[1];
        yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
        end = dd + "-" + mm + "-" + yyyy;

        let start_date = start + " " + stime;
        let end_date = end + " " + etime;
        fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "devices": tagsDevice,
                "start_date": start_date,
                "end_date": end_date
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log('nextpage', data)
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: page, currentPageSize: currentPageSize
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    getStartDate() {

        let stime = this.state.selectHistoryDateRange.startTimeHistory;
        let start = this.getCurrentDate(startHistoryDate);
        let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
        let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
        let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
        start = dd + "-" + mm + "-" + yyyy;

        //    let start_date = start+" "+stime;
        let start_date = start;

        return start_date;
    }
    getEndDate() {

        let etime = this.state.selectHistoryDateRange.endTimeHistory;
        let end = this.getCurrentDate(endHistoryDate)

        let dd = this.getCurrentDate(endHistoryDate).split("-")[0];
        let mm = this.getCurrentDate(endHistoryDate).split("-")[1];
        let yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
        end = dd + "-" + mm + "-" + yyyy;

        //    let end_date = end+" "+etime;
        let end_date = end;

        return end_date;
    }

    onPageSizeChange(page, pageSize) {

        let start_date = this.getStartDate();
        let end_date = this.getEndDate();
        console.log('start_date', start_date)
        console.log('end_date', end_date)

        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "devices": tagsDevice,
                "start_date": start_date,
                "end_date": end_date
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: page,
                    currentPageSize: pageSize
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }
    setFonSize(elm, fontsize) {
        elm.style.fontSize = fontsize;
    }

    getReportDeviceDaily = () => {

        console.log('setLoader')
        setLoader(true);
        let start_date = this.getStartDate();
        let end_date = this.getEndDate();
        console.log('start_date', start_date)
        console.log('end_date', end_date)

        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/report/getReportDeviceDaily`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "devices": tagsDevice,
                "start_date": start_date,
                "end_date": end_date
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log('data', data)
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    //  currentPage:page,
                    //  currentPageSize:pageSize
                })
                setLoader(false);
            })
            .catch(function (err) {
                console.log('err:', err);
                setLoader(false);
                // POST failed...
            });

        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }



    render() {

        const { onClickBackToReportPortal ,t} = this.props;
        const { isClickLoadReport, currentPage, currentPageSize, totalPage, isMobile } = this.state;

        const select = [];
        this.state.deviceNoList.map(device => {

            select.push({
                label: device.device_no,
                value: device.device_id,
            });
        });

        console.log(this.state.deviceList)
        return (
            <div className="gray-panel" >
                <h5 style={{ paddingLeft: '2em', cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                    <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        style={{ color: 'rgb(115, 134, 213)' }} />
                    <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft: 10, marginRight: 5, cursor: "pointer" }} />รายงานข้อมูล
                    </h5>

                <hr />

                <h5>
                    <span className="fa-stack fa-lg" style={{ color: 'orange' }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{ color: 'white' }} />
                    </span>
                    สรุปการใช้งานรายคัน
                    </h5>

                <hr />

                <form name="searchfrom" className="form-inline">
                    <div className="row">

                        <div className='form-group'>
                            <i className="fas fa-shipping-fast icon-for-calendar" style={{ fontSize: 20, marginLeft: isMobile ? '0px' :'27px' }} />
                            <TextBoxMultiCarFilter onChange={this.setMultiCar.bind(this)} />
                            &nbsp;
                        {isMobile && <div className="form-group col-md-12">{'\n'}</div>} 
                        <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                        {isMobile && <div className="col-md-12">{'\n'}</div>} 
                            <div className="input-group date" id="datetimepicker1">
                                <DateTimeRange
                                    small={true}
                                    isBack
                                    startDateId="MyDatePicker"
                                    endDateId="your_unique_end_date_id"
                                    onSelectDate={this.setRangeDate.bind(this)} />
                            </div>
                        &nbsp;
                        {isMobile && <div className="col-md-12">{'\n'}</div>}
                        <div className="btn-group">
                        <button
                            type="button"
                            className="btn btn-primary btn-report"
                            onClick={(e) => this.btnSearchHistoryClick(e)}
                        >
                            {'ตกลง'}
                        </button>
                        <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                            <span className="caret" />
                        </button>
                        <ul className={`dropdown-menu ${isClickLoadReport}`}>
                            {/* <li onClick={() => this.setState({isClickLoadReport: '', reportType: 'pdf'})} className="item-text"><a><i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/> รายงานแบบ PDF</a> */}
                            <li onClick={() => this.getReport()} className="item-text">
                                <button className="btn btn-light">
                                    <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />
                                    &nbsp;&nbsp;&nbsp;รายงานแบบ PDF
                                                </button>
                            </li>

                            <li onClick={() => this.setState({ isClickLoadReport: '', reportType: 'excel' })} className="item-text">
                                <button className="btn btn-light">
                                    <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                    <ReactToExcel
                                        // style={{ borderStyle: '' }}
                                        className="btn btn-light"
                                        table="table-to-excel"
                                        filename="summary"
                                        sheet="sheet 1"
                                        buttonText={"รายงานแบบ Excel"}
                                    />
                                </button>
                            </li>
                        </ul>
                    </div>
                        </div>
                        
                    </div>
                </form>


                <hr />

                {
                    this.state.deviceList != null && this.state.deviceList.length > 0 &&

                    <div>

                        <div id="printableTable" ref={el => (this.printableTable = el)}>
                            <table id='table-to-excel' border='1' style={{ fontSize: '14px', backgroundColor: 'white',width: isMobile ? '802px' : '100%' }} >
                                <div style={{ display: 'none', fontSize: '18px' }}>{('สรุปการใช้งานรายคัน')}</div>
                                <div style={{ display: 'none', fontSize: '14px' }}>{`ระหว่างวันที่  ${this.getStartDate()} ถึง ${this.getEndDate()}`}</div>
                                {/*<thead style={{wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}>*/}
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th style={{ width: '10%' }}>วันเดือนปี</th>
                                        <th>เวลาที่ใช้งานทั้งหมด</th>
                                        <th>สรุประยะทางการวิ่ง</th>
                                        <th>เวลาที่จอดติดเครื่อง</th>
                                        <th>จำนวนครั้งที่จอดเกิน(10นาที)</th>
                                        <th>จอดติดเครื่องนานที่สุด</th>
                                        <th>ความเร็วสูงสุดที่ใช้</th>
                                        <th>เวลาที่ขับเร็วสูงสุด</th>
                                        <th>จำนวนครั้งวิ่งเกินความเร็ว</th>
                                        <th>เครื่องยนต์</th>
                                        <th>ปริมาณการใช้น้ำมัน/ลิตร</th>
                                    </tr>
                                </thead>

                                {
                                    this.state.deviceList.map((data, key) => {
                                        return (
                                            <tbody style={{ textAlign: 'center' }}>
                                                <tr>
                                                    <td colSpan={11} style={{ backgroundColor: '#f5f5f5', fontSize: 'larger', textAlign: 'left' }} >
                                                        <b>&nbsp;{data.device_no}</b>
                                                    </td>
                                                </tr>
                                                {
                                                    data.details.map((i) => {
                                                        return (
                                                            <tr>
                                                                <td>{i.dtm}</td>
                                                                <td style={{textAlign:'right'}}>&nbsp;{i.working_duration}</td>
                                                                <td style={{textAlign:'right'}}>{i.total_distance}</td>
                                                                <td style={{textAlign:'right'}}>&nbsp;{i.stop_machine_on_duration}</td>
                                                                <td>{i.stop_machine_on_over_x_mins_times}</td>
                                                                <td style={{textAlign:'right'}}>&nbsp;{i.stop_machine_on_max_duration}</td>
                                                                <td>{i.max_speed}</td>
                                                                <td style={{textAlign:'right'}}>&nbsp;{i.max_speed_dtm}</td>
                                                                <td>{i.speed_over_times}</td>
                                                                <td>{i.machine_on_times}</td>
                                                                <td>{i.fuel_use}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                <tr >
                                                    <td>
                                                        <b>{'รวม'}</b>
                                                    </td>
                                                    {/* <td>{data.summary.speed_over_elapse}</td>
                                                    <td>{data.summary.speed_over_times}</td>
                                                    <td>{data.summary.max_speed}</td>
                                                    <td>{data.summary.violate_law}</td>
                                                    <td>{data.summary.vilate_license}</td> */}
                                                    
                                                    <td><b>{data.summary.working_duration}</b></td>
                                                    <td><b>{data.summary.total_distance}</b></td>
                                                    <td><b>{data.summary.stop_machine_on_duration}</b></td>
                                                    <td><b>{data.summary.stop_machine_on_over_x_mins_times}</b></td>
                                                    <td><b>{data.summary.stop_machine_on_max_duration}</b></td>
                                                    <td><b>{data.summary.max_speed}</b></td>
                                                    <td><b>{data.summary.max_speed_dtm}</b></td>
                                                    <td><b>{data.summary.speed_over_times}</b></td>
                                                    <td><b>{data.summary.machine_on_times}</b></td>
                                                    <td><b>{data.summary.fuel_use}</b></td>
                                                </tr>

                                            </tbody>
                                        )
                                    }
                                    )
                                }


                            </table>
                        </div>

                        <br />
                        <div className="push-up text-center ">
                            <div class="btn-group" role="group" aria-label="Basic example">
                                {/* <button  type="button" className="btn btn-light border border-secondary">
                                <ReactToPrint
                                    trigger={() => <a href="#">พิมพ์</a>}
                                    content={() => this.rpUseageSummary}
                                />
                            </button> */}


                                <button onClick={() => this.getReport()} type="button" className="btn btn-light border border-secondary">
                                    <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />
                                    รายงานแบบ PDF
                                </button>


                                <button type="button" className="btn btn-light border border-secondary">
                                    <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                    <ReactToExcel
                                        style={{ borderStyle: '' }}
                                        className="btn btn-light"
                                        table="table-to-excel"
                                        filename="summary"
                                        sheet="sheet 1"
                                        buttonText="รายงานแบบ Excel"
                                    />
                                </button>

                            </div>
                        </div>
                    </div>

                }
                {/* <RCPagination
                            onSelect={this.onPageSelect.bind(this)}
                            onShowSizeChange={this.onPageSizeChange.bind(this)}
                            total={totalPage}
                            pageSize={this.state.currentPageSize}
                        /> */}






            </div>
        );
    }
}

ReportSummary.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickBackToReportPortal: PropTypes.func.isRequired
}

export default ReportSummary;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportSummary.js